module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABRUlEQVQ4T2NkQANHfB0vC3K8MtZeffUXTOpqaCjbh59vz1hv2qcHE2PE0Ojn+Jn3B6uE/q5dX2FyZ1xc+H9w/n1gs3m/IIrGI34O8Qz/GbsYGBj4GRgY2NBN+8/wH6qeEeSKjwyM/8vAao74Or5nYvhv+eEP530+1k9s6K6A8T/95vslyPFb6e+fv0dhGv/bbN6P4WxcBhzxdfyPovGon5MdA8M/V+tNB2rPGBuz/pDi38jx7KO/ydmzv4/6OTQzMDDttt607xCGxvMBDgKffv2Ttd926DLINpBBIIUg9kEvO10+NqbHhhsOfMDQiMtpWKIM1alka6SfH4/6Ov612ryfhZEBHtM4Xf2fgYHxmK/jH3B0HPZxPMrIyHiL8f+/B4T8+Z+RSYGB4b8qWOMxd3ehf2y/4hn//+cjpJGRkekjwy/WRQAs4boD/JeaAgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guide/tour1.png
// module id = 4c5t
// module chunks = 1